<template>
    <span class="step-icon">
        <svg
            v-if="icon === 'user'"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
        >
            <IconUser />
        </svg>

        <svg
            v-else-if="icon === 'phone'"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <IconPhone />
        </svg>
        <svg
            v-else-if="icon === 'heart'"
            width="20px"
            height="18px"
            viewBox="0 0 20 18"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
        >
            <IconHeart />
        </svg>
        <svg
            v-else-if="icon === 'card'"
            width="24px"
            height="18px"
            viewBox="0 0 24 18"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
        >
            <IconCard />
        </svg>

        <svg
            v-else-if="icon === 'star'"
            width="22px"
            height="20px"
            viewBox="0 0 22 20"
            xmlns="http://www.w3.org/2000/svg"
            stroke="currentColor"
        >
            <IconStar />
        </svg>

        <svg
            v-else-if="icon === 'mail'"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <IconMail />
        </svg>
        <svg
            v-else-if="icon === 'lock'"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <IconLock />
        </svg>
        <svg
            v-else-if="icon === 'check'"
            xmlns="http://www.w3.org/2000/svg"
            class="h-6 w-6"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
        >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 13l4 4L19 7"
            />
        </svg>
        <span v-else></span>
    </span>
</template>

<script>
import IconUser from "./Icon-user";
import IconPhone from "./Icon-phone";
import IconHeart from "./Icon-heart";
import IconCard from "./Icon-card";
import IconStar from "./Icon-star";
import IconMail from "./Icon-mail";
import IconLock from "./Icon-lock";
export default {
    name: "Icons",
    components: {
        IconLock,
        IconMail,
        IconStar,
        IconCard,
        IconHeart,
        IconPhone,
        IconUser
    },
    props: ["icon"]
};
</script>
